import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Loading } from "@carbon/react";
import { Material } from "../../components";
import { useID } from "../../hooks";
import { useMaterial } from "../../hooks/useMaterials";

/**
 * The material DETAIL route's container — rebuilt on Carbon (Task 8): Carbon `Loading` replaces
 * the shared Tailwind `Loader` for the initial fetch, and the Tailwind flex wrapper (a layout
 * relic from the pre-AppShell page shell) is dropped — every other Carbon-migrated container
 * (`User.tsx`, `Tags.tsx`, `Materials.tsx`, ...) renders its content directly, no such wrapper.
 * `isSuccess` / `<Navigate to="/not-found" />` on failure is unchanged.
 */
const MaterialCnt = () => {
  const { t } = useTranslation();
  const id = useID();

  const { data: material, isLoading, isSuccess } = useMaterial(id);

  if (isLoading) return <Loading withOverlay description={t("cta.loading")} />;

  return isSuccess ? (
    <Material material={material} />
  ) : (
    <Navigate to="/not-found" />
  );
};

export default MaterialCnt;
